import { JSX } from 'react'
import './InteractiveBlock.css'


export interface InteractiveBlocksProps {
	flexDirection: 'row' | 'column'
	children: JSX.Element[]
}

export const InteractiveBlocks = (props: InteractiveBlocksProps) => {
	return (
		<div className={`interactive-blocks ${props.flexDirection}`}>
			{props.children}
		</div>
	)
}